import { BiLoaderAlt } from "react-icons/bi";

const Loader = () => {
  return (
    <div className="h-fit w-fit py-5 lg:py-10">
      <BiLoaderAlt size={42} color="#05A30D" className="animate-spin transition-all" />
    </div>
  );
};

export default Loader;